export const breakpoints = {
  screens: {
    sm: '600px',
    md: '840px',
    lg: '1024px',
    xl: '1266px',
  },
};
